module.exports = __webpack_public_path__ + "static/00028.8cf2d19f.jpg";